export const ACCOUNT_CREATED = 'Conta criada';
export const TRIAL_STARTED = 'Trial iniciado';
export const REGISTRATION_STARTED = 'Cadastro iniciado';
export const REGISTRATION_SUBMITED = 'Cadastro submetido';
export const REGISTRATION_SUBMITED_ERROR = 'Cadastro submetido - Erro';
export const REGISTRATION_ABORTED = 'Cadastro abandonado';
export const USER_ALREADY_EXIST = 'Cadastro existente bloqueado';
export const LINK_CLICKED = 'Link clicado';
export const BUTTON_CLICKED = 'Botão clicado';
export const MODAL_OPENED = 'Modal aberto';
export const MODAL_CLOSED = 'Modal fechado';
export const ACCESSED_BLOG = 'Blog acessado';
export const NEWSLETTER_SIGNED = 'Newsletter assinada';
export const CONTACT_SEND = 'Contato enviado';
export const ROI_REQUESTED = 'ROI solicitado';
export const ALTERNED_TAB = 'Aba selecionada';
export const NEXT_SLIDE = 'Slide avançado';
export const PREVIOUS_SLIDE = 'Slide regredido';
export const FAQ_TOGGLE = 'FAQ expandido';
export const NEWS_CLICKED = 'Mídia acessada';
export const WHATSAPP_CLICKED = 'Whatsapp clicado'
export const CHECKOUT_STARTED = 'Checkout iniciado'
export const CHECKOUT_ABORTED = 'Checkout abandonado'
export const CHECKOUT_ERROR = 'Checkout com erro'
export const CHECKOUT_SUCCESS = 'Checkout concluído'

export const trackActionSegment = (event, properties = {}) => {
	// console.log(event, properties)
	if (typeof window !== 'undefined' &&
		process.env.NODE_ENV === 'production' &&
		(!window.location.href.includes('gatsbyjs') || !window.location.href.includes('gtsb.io'))) {
		window.analytics.track(event, properties);
	}
};